import { Injectable } from '@angular/core';
import { GridInput } from '@it2go/data-grid';
import { IdInput } from '@libs/types/src/common/input-type/id.input';
import { OkObject } from '@it2go/types';
import {
    SocialProjectUserGridObject,
    SocialProjectUserObject,
} from '@libs/types/src/services/object-type/service/social-project-user.object';
import { SocialProjectUserCreateInput } from '@libs/types/src/services/input-type/services/project-user.create-input';
import { SocialProjectUserUpdateInput } from '@libs/types/src/services/input-type/services/project-user.update-input';
import { filterFrag } from './types/filter.types';
import { GqlServiceV2 } from '../modules/content/service/gql.service-v2';

@Injectable({ providedIn: 'root' })
export class ServiceSocialProjectUserGqlService extends GqlServiceV2 {

    public getSocialProjectUsers(input: GridInput | null, frag: string) {
        return this.query<SocialProjectUserGridObject>(
            `
                query($input: GridInput) {
                    socialProjectUser {
                        filter(input: $input) {
                            ${filterFrag}
                            items {
                                ${frag}
                            }
                        }
                    }
                }
            `,
            { input },
        );
    }

    public createSocialProjectUser(input: SocialProjectUserCreateInput) {
        return this.mutate<SocialProjectUserObject>(
            `
                mutation($input: SocialProjectUserCreateInput!) {
                    socialProjectUser {
                        create(input: $input) {
                            id
                        }
                    }
                }
            `,
            { input },
        );
    }

    public createManySocialProjectUsers(input: SocialProjectUserCreateInput[]) {
        return this.mutate<OkObject>(
            `
                mutation($input: [SocialProjectUserCreateInput!]!) {
                    socialProjectUser {
                        createMany(input: $input) {
                            ok
                        }
                    }
                }
            `,
            { input },
        );
    }

    public updateSocialProjectUser(input: SocialProjectUserUpdateInput) {
        return this.mutate<SocialProjectUserObject>(
            `
                mutation($input: SocialProjectUserUpdateInput!) {
                    socialProjectUser {
                        update(input: $input) {
                            id
                        }
                    }
                }
            `,
            { input },
        );
    }

    public deleteSocialProjectUser(input: IdInput) {
        return this.mutate<OkObject>(
            `
                mutation($input: IdInput!) {
                    socialProjectUser {
                        delete(input: $input) {
                            ok
                        }
                    }
                }
            `,
            { input },
        );
    }

}
